import { Component } from "@angular/core";

@Component({
  selector: 'kt-form-legend',
  templateUrl: './form-legend.component.html',
  styleUrls: ['./form-legend.component.scss']
})
export class FormLegendComponent {}